import { userRolesKey } from './constants.js';

export const getHotjarTiers = (user) => {
  const { email } = user;
  const roles = user[userRolesKey].join(',');
  return JSON.stringify({ email: email, tier: roles });
};
